var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',[_c('v-card-title',[_vm._v(" Edit Referral Code ")]),_c('RewardForm',{attrs:{"type":"UPDATE","referral":_vm.referral}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }